import React from "react"
import { connect } from "react-redux"

import KnowledgeAnalyseWidget from "./knowledge-analyse/KnowledgeAnalyseWidget"
import AddFeedFormActionButtonsWidgetContainer from "./knowledge-analyse/AddFeedFormActionButtonsWidgetContainer"
import AddFeedItemDetailsContainer from "./knowledge-analyse/AddFeedItemDetailsContainer"

const AddFeed = ({ hasAnalysisCompleted }) => (
    <div className="widgets-container clearfix row">
        <div className="col-xs-12 col-md-6 col-lg-5 col-xl-4" id="add-document">
            <KnowledgeAnalyseWidget />
        </div>
        {hasAnalysisCompleted && (
            <div className="col-xs-12 col-md-6 col-lg-7 col-xl-8 item-details-container">
                <div className="col-xs-12 widget-bottom-margin">
                    <AddFeedFormActionButtonsWidgetContainer />
                </div>
                <AddFeedItemDetailsContainer />
                <div className="col-xs-12 widget-bottom-margin">
                    <AddFeedFormActionButtonsWidgetContainer />
                </div>
            </div>
        )}
    </div>
)

const mapStateToProps = ({ presentation: { addFeed } }) => ({
    hasAnalysisCompleted: addFeed.hasAnalysisCompleted
})

export default connect(mapStateToProps)(AddFeed)
